import { render, staticRenderFns } from "./DropdownOptionSlot.vue?vue&type=template&id=ab927122&"
import script from "./DropdownOptionSlot.vue?vue&type=script&lang=js&"
export * from "./DropdownOptionSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports